import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLoadBalancer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-load-balancer';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M10.24 4.695v1.456L7.717 9.695 5.194 13.24H3.24v3.52h3.54l1.72 1.032 1.72 1.032.011.968.01.968h3.519v-1.946l1.705-1.028 1.705-1.029 1.795.002 1.795.002v-3.52l-1.009-.01-1.009-.011-2.489-3.5-2.489-3.5-.002-1.49-.002-1.49h-3.52zm1.993.107a.4.4 0 0 1-.138.12c-.123.078-.124.078-.229-.005-.058-.045-.106-.099-.106-.12s.11-.037.243-.037c.153 0 .238.016.23.042M11.24 12.3v4.94h-.739L8.63 16.118l-1.87-1.122v-1.365l2.23-3.135a515 515 0 0 1 2.24-3.135c.006-.001.01 2.222.01 4.939m3.757-1.76 2.245 3.16-.011.638-.011.639-1.878 1.131-1.878 1.132h-.744v-4.947c0-2.72.007-4.939.016-4.93s1.026 1.439 2.261 3.177m-2.941 8.6.066.1h-.284l.066-.1c.036-.055.07-.1.076-.1s.04.045.076.1"
    })
  }));
});
export default SvgLoadBalancer;